const isOn = (value) => String(value).toLowerCase() === 'true';
const readFlag = (built, name) => built ?? (typeof process !== 'undefined' ? process.env?.[name] : undefined);

export const SHOW_BENCHMARK_BLOCKS = isOn(readFlag(import.meta.env.REACT_APP_SHOW_BENCHMARK_BLOCKS, 'REACT_APP_SHOW_BENCHMARK_BLOCKS'));

export const SHOW_DELIVERY_TEAMS = isOn(readFlag(import.meta.env.REACT_APP_SHOW_DELIVERY_TEAMS, 'REACT_APP_SHOW_DELIVERY_TEAMS'));
